import { useId, useState } from "react";

// 라벨 옆 ⓘ 설명 — 마우스를 올리면 바로, 누르거나(터치) 키보드로 가도 보인다.
// 브라우저 title 툴팁은 1초쯤 가만히 올려 둬야 뜨고 터치 화면에서는 아예 안 떠서 직접 그린다.
// 터치는 누르면 열리고 다른 곳을 누르면(포커스가 빠지면) 닫힌다 — 누를 때 mouseenter·click 이 함께 와서 열기만 한다.
export default function HelpTip({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <span
      className="relative ml-1 inline-block"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label="설명"
        aria-describedby={open ? id : undefined}
        className="cursor-help text-slate-400 hover:text-slate-600"
        onClick={() => setOpen(true)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        ⓘ
      </button>
      {open && (
        <span
          id={id}
          role="tooltip"
          className="absolute left-0 top-full z-30 mt-1 w-64 whitespace-normal rounded-md bg-slate-900 px-3 py-2 text-xs font-normal leading-relaxed text-white shadow-lg"
        >
          {text}
        </span>
      )}
    </span>
  );
}
